import React, { useState } from "react";
import Utils from "../../../../utils/Utils";
import { Modal, Select } from "antd";
import { ListFilter } from "lucide-react";

function FilterResumeModal({
  setResumeFilterFlag,
  resumeFilterFlag,
  setResumeState,
  resumeState,
}) {
  const userDetail = Utils.getUserDetail();
  const [tempFilter, setTempFilter] = useState({
    resumeState: resumeState,
  });

  const resumeStateItem = [
    {
      value: "ALL",
      label: "All",
    },
    {
      value: "DRAFT",
      label: "Draft",
    },
    {
      value: "ACTIVE",
      label: "Active ",
    },
    {
      value: "RAW",
      label: "Raw ",
    },
  ];

  const handleSubmit = () => {
    setResumeState(tempFilter.resumeState);
    setResumeFilterFlag(false);
  };
  return (
    <Modal
      open={resumeFilterFlag}
      onCancel={() => setResumeFilterFlag(false)}
      footer={null}
      centered
      width={550}
      title={
        <div className="flex items-center gap-1 text-[1rem]">
          <ListFilter size={18} />
          <span>Filter</span>
        </div>
      }
    >
      <div className="mt-5">
        <p>Select resume state</p>
        <Select
          //   allowClear
          className="w-full mt-1"
          size="large"
          placeholder="Select resume state"
          value={tempFilter.resumeState}
          onChange={(value) => {
            // console.log(value);
            setTempFilter((prev) => ({
              ...prev,
              resumeState: value,
            }));
          }}
          options={resumeStateItem}
        />
      </div>
      <div className="flex items-center gap-3 mt-6">
        <button
          className="btn-white px-3 py-2 rounded-lg sm:w-1/2 w-full"
          onClick={() => setResumeFilterFlag(false)}
        >
          Cancel
        </button>

        <button
          //   disabled={selectedBatchGuides?.length < 1}
          onClick={handleSubmit}
          className={` btn-orange px-3 py-2 rounded-lg sm:w-1/2 w-full`}
        >
          Apply filter
        </button>
      </div>
    </Modal>
  );
}

export default FilterResumeModal;
